import axios from 'axios';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { getMsalInstance } from './msalInstance';
import { loginRequest } from './msalconfig';

export async function acquireVisitationToken(forceRefresh = false) {
    const instance = getMsalInstance();
    const account = instance.getActiveAccount() || instance.getAllAccounts()[0];
    if (!account) throw new Error('Sign in before using the Visitation backend.');
    try {
        const response = await instance.acquireTokenSilent({
            ...loginRequest, account, ...(forceRefresh ? { forceRefresh: true } : {})
        });
        if (!response.accessToken) throw new Error('Entra did not return a Visitation access token.');
        sessionStorage.setItem('accessToken', response.accessToken);
        return response.accessToken;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            error.message = 'Your Visitation session requires sign-in. Sign out and sign in again to continue.';
        }
        throw error;
    }
}

export function addVisitationAuth(client) {
    client.interceptors.request.use(async request => {
        const token = await acquireVisitationToken(Boolean(request._visitationRetry));
        if (request.signal?.aborted) throw new axios.CanceledError();
        request.headers = { ...request.headers, Authorization: `Bearer ${token}` };
        return request;
    });
    client.interceptors.response.use(response => response, error => {
        const request = error.config;
        if (error.response?.status !== 401 || !request || request._visitationRetry || request.signal?.aborted) {
            return Promise.reject(error);
        }
        return client.request({ ...request, _visitationRetry: true });
    });
}
